<template>
    <div id="inscription">
        <b-row class="backInfoMain2">

            <s-menuSave :msg="sendMsg" newBtn :btnSaveDisabled="checkAllField" @new="menuNew()" saveBtn @save="menuSave()" deleteBtn @delete="menuDelete(activeObj.id)"></s-menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <!--Affichage de la liste-->
                <s-itemList
                    v-if="fromApiAccount" 
                    :content="fromApiAccount" 
                    :returnValue.sync="activeObj" 
                    showField="number" 
                    showField2="description0" 
                    activeField="isActive" 
                    returnField="id"
                    :selectedItems="activeObj"
                    getSubCol="description0"
                    multiColonne
                    :fields="fields"
                    @getRowdDetail="getRowdDetail">
                </s-itemList>
            </b-col>
            <!--Fin section de gauche-->

<!--****************************************************************************************************************************************************************-->
            
            <!--Section de droite-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">
<!--{{activeObj}}-->
                
                <!--DATE / PERIODE-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('g_Date')}}</div>
                            <div class="itemContain txtLabel">
                                <!--Date-->
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="8" :xl="$dateSize1()">
                                            <s-datePicker name="dateTr" :dateValue.sync="activeObj.dateTr" style="margin-top: 5px" ></s-datePicker>
                                    </b-col>
                                </b-row>
                                <br>
                                <!--Période-->
                                <b-row>
                                    <b-col cols="3">
                                        {{$t('ins_Periode')}}
                                    </b-col>
                                    <b-col cols="3">
                                        1
                                    </b-col>
                                </b-row>
                                <!--Numéro-->
                                <b-row>
                                    <b-col cols="3">
                                        {{$t('ins_Numero')}}
                                    </b-col>
                                    <b-col cols="3">
                                        1
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - DATE / PERIODE-->

                <!--DESCRIPTION-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('ins_Description')}}</div>
                            <div class="itemContain">
                                <b-row align-v="center" class="txtSign">
                                        <b-form-textarea
                                            id="Note"
                                            v-model="activeObj.description"
                                            rows="5"
                                            max-rows="5"
                                            maxlength="255"
                                            no-resize
                                            style="width: 100%; margin-top: 5px; margin-left: 15px; margin-right: 15px;">
                                        </b-form-textarea>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - DESCRIPTION-->

                <!--COMMENTAIRE-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('ins_Commentaires')}}</div>
                            <div class="itemContain">
                                <b-row align-v="center" class="txtSign">
                                        <b-form-textarea
                                            id="Comments"
                                            v-model="activeObj.comments"
                                            rows="5"
                                            max-rows="5"
                                            maxlength="255"
                                            no-resize
                                            style="width: 100%; margin-top: 5px; margin-left: 15px; margin-right: 15px;">
                                        </b-form-textarea>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - COMMENTAIRE-->

            </b-col>


                <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                    <!--TAXES-->
                    <inscriptionTaxeViewer
                        :taxes.sync="taxes">
                    </inscriptionTaxeViewer>
                    <!--FIN - TAXES-->

                    <!--COMPTE INSCRIPTION-->
                    <div class="itemMain">
                        <div class="itemSubTitle">{{$t('ins_Inscription')}}</div>
                        <div class="itemContain">

                        <div :class="calculBalance == 0 ? 'balance':'balanceEr'" style="margin-top: 0px; padding-left: 5px;">{{$t('ins_Solde') + ' : ' + $FM(calculBalance, 2)}}</div>

                        <b-row align-v="center" class="txtSign MargeTop15 PadLeft15">
                            <b-form-checkbox switch :size="chkSize" v-model="autoTax">{{$t('ins_CalculAutomatiqueDesTaxes')}}</b-form-checkbox>
                        </b-row>

                                <!--ENTETE DES INSCRIPTIONS-->
                                <b-row align-v="center" class="txtSign MargeTop15">
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.compte" :sm="inscriptionWidth.compte" :md="inscriptionWidth.compte" :lg="inscriptionWidth.compte" :xl="inscriptionWidth.compte">
                                        {{$t('ins_Compte')}}
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.description" :sm="inscriptionWidth.description" :md="inscriptionWidth.description" :lg="inscriptionWidth.description" :xl="inscriptionWidth.description">
                                        {{$t('ins_Description')}}
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.debit" :sm="inscriptionWidth.debit" :md="inscriptionWidth.debit" :lg="inscriptionWidth.debit" :xl="inscriptionWidth.debit">
                                        {{$t('ins_Debit')}}
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.credit" :sm="inscriptionWidth.credit" :md="inscriptionWidth.credit" :lg="inscriptionWidth.credit" :xl="inscriptionWidth.credit">
                                        {{$t('ins_Credit')}}
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.projet" :sm="inscriptionWidth.projet" :md="inscriptionWidth.projet" :lg="inscriptionWidth.projet" :xl="inscriptionWidth.projet">
                                        {{$t('ins_Projet')}}
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.delete" :sm="inscriptionWidth.delete" :md="inscriptionWidth.delete" :lg="inscriptionWidth.delete" :xl="inscriptionWidth.delete">
                                        <!---->
                                    </b-col>
                                </b-row>
                                <!-- FIN - ENTETE DES INSCRIPTIONS-->

                                <span v-for="(item, index) in inscriptionLine" :key="item.index">
                                    <b-row align-v="center" class="txtSign">
                                        <!--COMPTE-->
                                        <b-col class="inscriptionLine" :xs="inscriptionWidth.compte" :sm="inscriptionWidth.compte" :md="inscriptionWidth.compte" :lg="inscriptionWidth.compte" :xl="inscriptionWidth.compte">
                                            <!--Champs d'entrer pour le compte-->
                                            <b-form-input 
                                                :id="'compte' + index"
                                                name="accountNumber"
                                                class="txtPrincipal" 
                                                :state="validateAccountState(index)"
                                                type="text" 
                                                maxlength="15"
                                                autocomplete="off" 
                                                v-model="inscriptionLine[index].compte"
                                                @click="autoComplete(index, item.compte)"
                                                @keyup="validateAccount(index)">
                                            </b-form-input>
                                            <!-- FIN - Champs d'entrer pour le compte-->
                                            
                                            <!--AUTOCOMPLETION - SELECTION DE TOUS LES COMPTES-->
                                            <div class="colomnSelectionMenu" v-show="item.openMenu">
                                                
                                                <!--{{accountSearch}}-->
                                                
                                                <b-row style="margin-bottom: 5px;">
                                                    <!--Bouton fermer-->
                                                    <b-col cols="6">
                                                        <b-button :variant="getTheme.warning" style="width: 80%;" @click="item.openMenu=false">{{$t("g_Fermer")}}</b-button>
                                                    </b-col>
                                                    <!--Bouton effacer-->
                                                    <b-col cols="6" align="right">
                                                        <b-button :variant="getTheme.danger" style="width: 80%;" @click="item.compte=''">{{$t("g_Efface")}}</b-button>
                                                    </b-col>
                                                </b-row>
                                        
                                                <div class="scrollIn">
                                                    <!--List des items de l'autoCompletion-->
                                                    <b-list-group class="MargeTop5">
                                                        <b-list-group-item 
                                                            :class="'cursorPoint btnStyle ' + cssFirstLetter"
                                                            v-for="(account) in rechercheAutoComplete" 
                                                            :key="account.index" 
                                                            @click="selectAccount(account.number)">

                                                                <b-row>
                                                                    <b-col cols="3">
                                                                        <span>
                                                                            {{account.number}}
                                                                        </span>
                                                                    </b-col>
                                                                    <b-col cols="9">
                                                                        <span>
                                                                            {{account.description0}}
                                                                        </span>
                                                                    </b-col>
                                                                </b-row>

                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </div>
                                            </div>
                                            <!--FIN - AUTOCOMPLETION - SELECTION DE TOUS LES COMPTES-->
                                        </b-col>


                                        <!--DESCRIPTION-->
                                        <b-col class="inscriptionLine" :xs="inscriptionWidth.description" :sm="inscriptionWidth.description" :md="inscriptionWidth.description" :lg="inscriptionWidth.description" :xl="inscriptionWidth.description">
                                            <b-form-input 
                                                id="accountNumber"
                                                name="accountNumber"
                                                class="txtPrincipal" 
                                                type="text" 
                                                maxlength="15"
                                                :disabled="!validateAccountState(index)"
                                                v-model="item.description">
                                            </b-form-input>
                                        </b-col>
                                        <!--DEBIT-->
                                        <b-col class="inscriptionLine" :xs="inscriptionWidth.debit" :sm="inscriptionWidth.debit" :md="inscriptionWidth.debit" :lg="inscriptionWidth.debit" :xl="inscriptionWidth.debit">
                                            <s-currencyInput
                                                :Name="'debit' + index" 
                                                class="" 
                                                append="$" 
                                                decimal="2" 
                                                :disabled="!validateAccountState(index)" 
                                                v-model="item.debit"
                                                onKeyPress="zeroCredit"
                                                :valueKeyPress="index"
                                                @zeroCredit="zeroCredit"
                                                onBlur="calculTaxes"
                                                @calculTaxes="calculTaxes()"
                                                :enteredValue.sync="inscriptionLine[index].debitEntered">
                                            </s-currencyInput>
                                        </b-col>
                                        <!--CREDIT-->
                                        <b-col class="inscriptionLine" :xs="inscriptionWidth.credit" :sm="inscriptionWidth.credit" :md="inscriptionWidth.credit" :lg="inscriptionWidth.credit" :xl="inscriptionWidth.credit">
                                            <s-currencyInput 
                                                :Name="'credit' + index" 
                                                class="" 
                                                append="$" 
                                                decimal="2" 
                                                :disabled="!validateAccountState(index)" 
                                                v-model="item.credit"
                                                onKeyPress="zeroDebit"
                                                :valueKeyPress="index"
                                                @zeroDebit="zeroDebit"
                                                onBlur="calculTaxes"
                                                @calculTaxes="calculTaxes()"
                                                :enteredValue.sync="inscriptionLine[index].creditEntered">
                                            </s-currencyInput>
                                        </b-col>
                                        <!--PROJET-->
                                        <b-col class="inscriptionLine" :xs="inscriptionWidth.projet" :sm="inscriptionWidth.projet" :md="inscriptionWidth.projet" :lg="inscriptionWidth.projet" :xl="inscriptionWidth.projet">
                                            <b-form-input 
                                                id="accountNumber"
                                                name="accountNumber"
                                                class="txtPrincipal" 
                                                :disabled="!validateAccountState(index)"
                                                type="text" 
                                                maxlength="15" 
                                                v-model="item.projet">
                                            </b-form-input>
                                        </b-col>
                                        <!--SUPPRIMER LIGNE-->
                                        <b-col class="inscriptionLine" :xs="inscriptionWidth.delete" :sm="inscriptionWidth.delete" :md="inscriptionWidth.delete" :lg="inscriptionWidth.delete" :xl="inscriptionWidth.delete">

                                            <template v-if="index == inscriptionLine.length - 1"><!--Ne pas afficher le signe MOINS dans la derniere ligne-->
                                                <template v-if="item.delete==false">
                                                    <b-icon-arrow-bar-down :variant="getTheme.primary" scale="1.5" class="cursorPoint" @click="autoCompleteBank(index, item.compte)"></b-icon-arrow-bar-down>
                                                    <b-icon-dash-circle-fill :variant="getTheme.primary" scale="1.5" class="cursorPoint MargeLeft15" @click="inscriptionLine[index].delete=true"></b-icon-dash-circle-fill>
                                                </template>
                                                <template v-elseif="item.delete==true">
                                                    <b-icon-x-circle-fill scale="1.5" :variant="getTheme.danger" class="cursorPoint" @click="inscriptionLine[index].delete=false"></b-icon-x-circle-fill>
                                                    <b-icon-check-circle-fill scale="1.5" :variant="getTheme.success" class="cursorPoint MargeLeft15" @click="deleteTransactionLine(index)"></b-icon-check-circle-fill>
                                                </template>
                                            </template>


                                            <!--AUTOCOMPLETION - SELECTION DES COMPTES BANCAIRES-->
                                            <div class="colomnSelectionBank" v-show="item.openBank">
                                                
                                                <!--{{accountSearch}}-->
                                                
                                                <b-row style="margin-bottom: 5px;">
                                                    <!--Bouton fermer-->
                                                    <b-col cols="6">
                                                        <b-button :variant="getTheme.warning" style="width: 80%;" @click="item.openBank=false">{{$t("g_Fermer")}}</b-button>
                                                    </b-col>
                                                    <!--Bouton effacer-->
                                                    <b-col cols="6" align="right">
                                                        <b-button :variant="getTheme.danger" style="width: 80%;" @click="item.compte=''">{{$t("g_Efface")}}</b-button>
                                                    </b-col>
                                                </b-row>
                                        
                                                <div class="scrollIn">
                                                    <!--List des items de l'autoCompletion-->
                                                    <b-list-group style="margin-top: 5px">
                                                        <b-list-group-item 
                                                            :class="'cursorPoint btnStyle ' + cssFirstLetter"
                                                            v-for="(account) in fromApiAccount" 
                                                            :key="account.index" 
                                                            @click="selectAccountBalance(account.number)">

                                                                <b-row>
                                                                    <b-col cols="3">
                                                                        <span>
                                                                            {{account.number}}
                                                                        </span>
                                                                    </b-col>
                                                                    <b-col cols="9">
                                                                        <span>
                                                                            {{account.description0}}
                                                                        </span>
                                                                    </b-col>
                                                                </b-row>

                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </div>
                                            </div>
                                            <!--FIN - AUTOCOMPLETION - SELECTION DES COMPTES BANCAIRES-->


                                        </b-col>
                                    </b-row>

                                    <!--LIGNE D'AFFICHAGE MONTANT TAXES INCLUSE-->
                                    <b-row align-v="center" class="txtSign">
                                        <!--COMPTE-->
                                        <b-col class="inscriptionLineTaxeIn" :xs="inscriptionWidth.compte" :sm="inscriptionWidth.compte" :md="inscriptionWidth.compte" :lg="inscriptionWidth.compte" :xl="inscriptionWidth.compte">
                                        </b-col>
                                        <!--DESCRIPTION-->
                                        <b-col align="right" class="inscriptionLineTaxeIn" style="padding-right: 20px" :xs="inscriptionWidth.description" :sm="inscriptionWidth.description" :md="inscriptionWidth.description" :lg="inscriptionWidth.description" :xl="inscriptionWidth.description">
                                            {{$t('tax_MontantEntre')}}
                                        </b-col>
                                        <!--DEBIT-->
                                        <b-col class="inscriptionLineTaxeIn" :xs="inscriptionWidth.debit" :sm="inscriptionWidth.debit" :md="inscriptionWidth.debit" :lg="inscriptionWidth.debit" :xl="inscriptionWidth.debit">
                                            <!--{{inscriptionLine[index].debitEntered}}-->
                                            {{$FM(inscriptionLine[index].debitEntered, 2)}}
                                        </b-col>
                                        <!--CREDIT-->
                                        <b-col class="inscriptionLineTaxeIn" :xs="inscriptionWidth.credit" :sm="inscriptionWidth.credit" :md="inscriptionWidth.credit" :lg="inscriptionWidth.credit" :xl="inscriptionWidth.credit">
                                            <!--{{inscriptionLine[index].creditEntered}}-->
                                            {{$FM(inscriptionLine[index].creditEntered, 2)}}
                                        </b-col>
                                        <!--PROJET-->
                                        <b-col class="inscriptionLineTaxeIn" :xs="inscriptionWidth.projet" :sm="inscriptionWidth.projet" :md="inscriptionWidth.projet" :lg="inscriptionWidth.projet" :xl="inscriptionWidth.projet">
                                        </b-col>
                                        <!--SUPPRIMER LIGNE-->
                                        <b-col class="inscriptionLineTaxeIn" :xs="inscriptionWidth.delete" :sm="inscriptionWidth.delete" :md="inscriptionWidth.delete" :lg="inscriptionWidth.delete" :xl="inscriptionWidth.delete">
                                        </b-col>
                                    </b-row>
                                    <!--FIN - LIGNE D'AFFICHAGE MONTANT TAXES INCLUSE-->
                                </span>

                                <!--Sous-total des débits / crédits-->
                                <b-row align-v="center" class="txtSign" style="margin-top: 15px;">
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.compte" :sm="inscriptionWidth.compte" :md="inscriptionWidth.compte" :lg="inscriptionWidth.compte" :xl="inscriptionWidth.compte">
                                        <!---->
                                    </b-col>
                                    <b-col class="inscriptionLine" align="right" :xs="inscriptionWidth.description" :sm="inscriptionWidth.description" :md="inscriptionWidth.description" :lg="inscriptionWidth.description" :xl="inscriptionWidth.description">
                                        <span style="font-size: 15px;">{{$t('g_SousTotal')}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.debit" :sm="inscriptionWidth.debit" :md="inscriptionWidth.debit" :lg="inscriptionWidth.debit" :xl="inscriptionWidth.debit">
                                        <span style="padding-left: 10px; font-size: 15px;">{{$FM(totalDebit, 2)}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.credit" :sm="inscriptionWidth.credit" :md="inscriptionWidth.credit" :lg="inscriptionWidth.credit" :xl="inscriptionWidth.credit">
                                        <span style="padding-left: 10px; font-size: 15px;">{{$FM(totalCredit, 2)}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.projet" :sm="inscriptionWidth.projet" :md="inscriptionWidth.projet" :lg="inscriptionWidth.projet" :xl="inscriptionWidth.projet">
                                        <!---->
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.delete" :sm="inscriptionWidth.delete" :md="inscriptionWidth.delete" :lg="inscriptionWidth.delete" :xl="inscriptionWidth.delete">
                                        <!---->
                                    </b-col>
                                </b-row>
                                <!-- FIN - Sous-total des débits / crédits-->

                                <!--Total TAXES débits / crédits-->
                                <b-row align-v="center" class="txtSign" style="margin-top: 15px;">
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.compte" :sm="inscriptionWidth.compte" :md="inscriptionWidth.compte" :lg="inscriptionWidth.compte" :xl="inscriptionWidth.compte">
                                        <!---->
                                    </b-col>
                                    <b-col class="inscriptionLine" align="right" :xs="inscriptionWidth.description" :sm="inscriptionWidth.description" :md="inscriptionWidth.description" :lg="inscriptionWidth.description" :xl="inscriptionWidth.description">
                                        <span style="font-size: 15px;">{{$t('tax_TotalDesTaxes')}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.debit" :sm="inscriptionWidth.debit" :md="inscriptionWidth.debit" :lg="inscriptionWidth.debit" :xl="inscriptionWidth.debit">
                                        <span style="padding-left: 10px; font-size: 15px;">{{$FM(totalTaxDebit, 2)}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.credit" :sm="inscriptionWidth.credit" :md="inscriptionWidth.credit" :lg="inscriptionWidth.credit" :xl="inscriptionWidth.credit">
                                        <span style="padding-left: 10px; font-size: 15px;">{{$FM(totalTaxCredit, 2)}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.projet" :sm="inscriptionWidth.projet" :md="inscriptionWidth.projet" :lg="inscriptionWidth.projet" :xl="inscriptionWidth.projet">
                                        <!---->
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.delete" :sm="inscriptionWidth.delete" :md="inscriptionWidth.delete" :lg="inscriptionWidth.delete" :xl="inscriptionWidth.delete">
                                        <!---->
                                    </b-col>
                                </b-row>
                                <!-- FIN - Total TAXES débits / crédits-->

                                <!--Total TAXES débits / crédits-->
                                <b-row align-v="center" class="txtSign" style="margin-top: 15px;">
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.compte" :sm="inscriptionWidth.compte" :md="inscriptionWidth.compte" :lg="inscriptionWidth.compte" :xl="inscriptionWidth.compte">
                                        <!---->
                                    </b-col>
                                    <b-col class="inscriptionLine" align="right" :xs="inscriptionWidth.description" :sm="inscriptionWidth.description" :md="inscriptionWidth.description" :lg="inscriptionWidth.description" :xl="inscriptionWidth.description">
                                        <span style="font-size: 15px;">{{$t('g_Total')}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.debit" :sm="inscriptionWidth.debit" :md="inscriptionWidth.debit" :lg="inscriptionWidth.debit" :xl="inscriptionWidth.debit">
                                        <span style="padding-left: 10px; font-size: 15px;">{{$FM(totalDebit + totalTaxDebit, 2)}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.credit" :sm="inscriptionWidth.credit" :md="inscriptionWidth.credit" :lg="inscriptionWidth.credit" :xl="inscriptionWidth.credit">
                                        <span style="padding-left: 10px; font-size: 15px;">{{$FM(totalCredit + totalTaxCredit, 2)}}</span>
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.projet" :sm="inscriptionWidth.projet" :md="inscriptionWidth.projet" :lg="inscriptionWidth.projet" :xl="inscriptionWidth.projet">
                                        <!---->
                                    </b-col>
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.delete" :sm="inscriptionWidth.delete" :md="inscriptionWidth.delete" :lg="inscriptionWidth.delete" :xl="inscriptionWidth.delete">
                                        <!---->
                                    </b-col>
                                </b-row>
                                <!-- FIN - Total TAXES débits / crédits-->

                                <b-row align-v="center" class="txtSign" style="margin-top: 15px;">
                                    <b-col class="inscriptionLine" :xs="inscriptionWidth.compte" :sm="inscriptionWidth.compte" :md="inscriptionWidth.compte" :lg="inscriptionWidth.compte" :xl="inscriptionWidth.compte">
                                        <b-button variant="success" @click="calculTaxes()">Taxes</b-button>
                                    </b-col>
                                </b-row>

                                <!--Signe PLUS - pour ajouter ligne de transaction - non utiliser dans les inscription-->
                                <!--<b-row align-v="center" style="height: 50px; margin-top: 5px;">
                                    <b-icon-plus-circle-fill 
                                        :variant="getTheme.warning" 
                                        scale="3" 
                                        class="cursorPoint" 
                                        style="margin-left: 30px"
                                        @click="addTransactionLine()">
                                    </b-icon-plus-circle-fill>
                                </b-row>-->

                                <!--{{fromApiAccount}}-->

                        </div>
                    </div>
                    <!--FIN - COMPTE INSCRIPTION-->

<!--{{inscriptionLine}}-->

                </b-col>
            <!--FIN - Section de droite-->

            <br><br>
            
        </b-row>     
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios';
import {dataService} from '@/services'
import store from '@/store'
import inscriptionTaxeViewer from '@/components/inscription/inscriptionTaxeViewer/inscriptionTaxeViewer.vue'

export default{
    name: "inscription",
    components: {
        inscriptionTaxeViewer
    },
    data() {
        return{
            apiAddGetAccount: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiComptes, //adress de la requete chargement des comptes
            apiAddGet1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiNomDeLaVariable, //adress de la requete principale vers l'API
            apiAddPost1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiNomDeLaVariable, //adress de la requete principale vers l'API
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            output: 'null', //Message de reception de l'API
            error: null, //Message d'erreur de l'API
            fromApi: null, //Contenu de l'API
            InitialState: null, //Format initial de : activeObj
            inscriptionLineInitial:[],
            autoTax: true,
            //Objet en cours de modification
            accountSearch:{
                accountIndex: 0,
                searchValue: ''
            },
            inscriptionWidth:{
                compte: 2,
                description: 3,
                debit: 2,
                credit: 2,
                projet: 2,
                delet: 1
            },
            inscriptionLine:[
                {
                    compte: '',
                    description: '',
                    debit: 0,
                    debitEntered: 0,
                    credit: 0,
                    creditEntered: 0,
                    projet: '',
                    delete: false,
                    openMenu: false,
                    openBank: false
                }
            ],
            activeObj:{
                dateTr: null,
                description: '',
                comments: ''

            },
            solde: 0,
            fields: [
                {
                    colName : "id",
                    label: "g_id",
                    width: 75,
                },
                {
                    colName : "number",
                    alignH : "left",
                    label: "acc_Numero",
                    width: 150,
                    show: true,
                },
                {
                    colName : "description0",
                    alignH : "left",
                    label: "acc_Description1",
                    show: true,
                },
                {
                    colName : "description1",
                    alignH : "left",
                    label: "acc_Description2",
                }
                
            ],
            taxesInitial: null,
            taxes: {
                glFDebit: 0,
                glPDebit: 0,
                glFIncludeDebit: 0,
                glPIncludeDebit: 0,
                glMotelDebit: 0,
                glTireDebit: 0,
                glFCredit: 0,
                glPCredit: 0,
                glFIncludeCredit: 0,
                glPIncludeCredit: 0,
                glMotelCredit: 0,
                glTireCredit: 0
            }
        }
    },
    methods: {
        pushto(link) {
            this.$router.push(link)
        },
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            this.inscriptionLine = this.$CObj(this.inscriptionLineInitial)
            this.taxes = this.$CObj(this.taxesInitial)
        },
        resetTaxes(){
            this.taxes = this.$CObj(this.taxesInitial)
        },
        menuNew(){
            this.resetAll()
        },
        loadApiAccount() {
            this.sendMsg = '4'
            dataService.getLGAccounts().then( response =>{
              //this.$store.dispatch('updateGLAccounts', response.data)
              this.fromApiAccount = response.data
              this.sendMsg = ''
            }).catch(e => {
                  this.errors.push(e)
                  this.sendMsg = '2'
            })
        },
        /**
         * Retourne les détails de l'inscription 
         * @param {int} id - id de l'inscription
         */
         getRowdDetail(id){
            alert("getRowdDetail id = "+id);
            this.sendMsg = '-'
            dataService.getGlAccount(id)
            .then((response) => {
                console.log(response);
                if(response.statusText == 'OK') {
                    let data = response.data.data;
                    console.log(data);
                    //this.activeObj = data[0]
                    this.sendMsg2 ='getGlAccount OK';
                    //this.originalObj = this.$CObj(this.activeObj)
                    //this.InitialState = this.$CObj(response.data.addons.classes[0])
                }
                this.sendMsg = ''
            })
            .catch((error) => {
                this.sendMsg = ''
                this.sendMsg2 = error;
            });
        },
        loadApi() {
            //this.sendMsg = '4'
            //axios.get(this.apiAddGet1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
            //    .then(response => {
            //      this.fromApi = response.data
            //      this.sendMsg = ''
            //    })
            //    .catch(e => {
            //      this.errors.push(e)
            //      this.sendMsg = '2'
            //    })
        },
        menuSave(){
            this.sendMsg = '-'
            let currentObj = this;
            let t = this.activeObj

            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                axios.post(this.apiAddPost1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {
                    //id: t.id,
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.sendMsg = '1'
                    currentObj.output = response.data;
                })
                .catch(function (error) {
                    currentObj.sendMsg = '2'
                    currentObj.output = error;
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                axios.patch(this.apiAddPost1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {
                    //id: t.id,
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.sendMsg = '1'
                    currentObj.output = response.data;
                })
                .catch(function (error) {
                    currentObj.sendMsg = '2'
                    currentObj.output = error;
                });


            }
                setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        menuDelete(id){
            if (this.activeObj.id != '0')
                {
                    this.sendMsg = '-'
                    this.output = null
                    let currentObj = this;
                    axios.delete(this.apiAdd1 + '?' + this.apiAddPost1 + '&licence=' + this.$store.getters.getworkLicence + '&id=' + id + '&status=false', {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                    .then(function (response) {
                        currentObj.sendMsg = '1'
                        currentObj.output = response.data;
                    })
                    .catch(function (error) {
                        currentObj.sendMsg = '2'
                        currentObj.output = error;
                    });

                    setTimeout(() => { this.sendMsg = '' }, 5000)

                }
        },
        addTransactionLine(){
            if(this.inscriptionLine[this.inscriptionLine.length - 1].compte != '')
            {
                var inscriptionLineAdd = {
                        compte: '',
                        description: '',
                        debit: 0,
                        debitEntered: 0,
                        credit: 0,
                        creditEntered: 0,
                        projet: '',
                        delete: false,
                        openMenu: false
                    }

                this.inscriptionLine.push(inscriptionLineAdd)

            }
        },
        deleteTransactionLine(id) {
            //console.log("DELETE : " + id)
            this.inscriptionLine.splice(id, 1);
            if (this.inscriptionLine.length == 0){this.addTransactionLine()}
            this.autoComplete(0)
            this.inscriptionLine[0].openMenu = false
            //this.inscriptionLine = this.$CObj(this.inscriptionLine)
            this.calculTaxes()
        },
        getFromApiAccountIndexFromNumber(accountNumber){
            if (this.fromApiAccount)
            {
                var fromAPIAccountId = ''
                var i = 0 

                for (i = 0; i < this.fromApiAccount.length; i++)
                {
                    if (this.fromApiAccount[i].number == accountNumber)
                    {
                        fromAPIAccountId = i
                    }
                }

                return fromAPIAccountId
            }
            else
            {return 0}
        },
        selectAccount(accountNumber){

            //this.inscriptionLine[lineId].description = ''
            var fromAPIAccountId = this.getFromApiAccountIndexFromNumber(accountNumber)

            this.inscriptionLine[this.accountSearch.accountIndex].description = this.fromApiAccount[fromAPIAccountId].description0
            this.inscriptionLine[this.accountSearch.accountIndex].compte = this.fromApiAccount[fromAPIAccountId].number

            this.addTransactionLine()

            this.inscriptionLine[this.accountSearch.accountIndex].openMenu = false

            //if(accountId == -1)
            //{this.inscriptionLine[this.accountSearch.accountIndex].description = ''}
            //else
            //{this.inscriptionLine[this.accountSearch.accountIndex].description = this.fromApiAccount[accountId].description0}
        },
        selectAccountBalance(accountNumber){ //FONCTION QUI TRANSFERT LE MONTANT DANS LE COMPTE CONTRAIRE SOIT DÉBIT OU CRÉDIT POUR LE BALANCEMENT AUTOMATIQUE

            //this.inscriptionLine[lineId].description = ''
            var fromAPIAccountId = this.getFromApiAccountIndexFromNumber(accountNumber)

            this.inscriptionLine[this.accountSearch.accountIndex + 1].description = this.fromApiAccount[fromAPIAccountId].description0
            this.inscriptionLine[this.accountSearch.accountIndex + 1].compte = this.fromApiAccount[fromAPIAccountId].number

            if (this.inscriptionLine[this.accountSearch.accountIndex].credit != 0)
            {
                this.inscriptionLine[this.accountSearch.accountIndex + 1].debit =this.inscriptionLine[this.accountSearch.accountIndex].credit
                this.inscriptionLine[this.accountSearch.accountIndex + 1].debitEntered =this.inscriptionLine[this.accountSearch.accountIndex].credit
                //this.inscriptionLine[this.accountSearch.accountIndex].debitEntered =this.inscriptionLine[this.accountSearch.accountIndex].credit
            }

            if (this.inscriptionLine[this.accountSearch.accountIndex].debit != 0)
            {
                this.inscriptionLine[this.accountSearch.accountIndex + 1].credit = this.inscriptionLine[this.accountSearch.accountIndex].debit
                this.inscriptionLine[this.accountSearch.accountIndex + 1].creditEntered = this.inscriptionLine[this.accountSearch.accountIndex].debit
                //this.inscriptionLine[this.accountSearch.accountIndex].creditEntered = this.inscriptionLine[this.accountSearch.accountIndex].debit
            }

            //alert(this.inscriptionLine[this.accountSearch.accountIndex + 1].creditEntered)

            this.addTransactionLine()

            this.inscriptionLine[this.accountSearch.accountIndex].openBank = false

        },
        autoComplete(indexMenu){
            //console.log("COMPTE : " + indexMenu)
            this.accountSearch.accountIndex=indexMenu
            this.accountSearch.searchValue=this.inscriptionLine[indexMenu].compte

            if (this.inscriptionLine.length > 0)
            {
                var i = 0
                for (i = 0; i < this.inscriptionLine.length; i++)
                {
                    //console.log(indexMenu + " : " + i)

                    if (i == indexMenu)
                    {this.inscriptionLine[i].openMenu = true}
                    else
                    {this.inscriptionLine[i].openMenu = false}
                }
            }
        },
        autoCompleteBank(indexMenu){
            //console.log("COMPTE : " + indexMenu)
            //this.accountSearch.accountIndex=indexMenu
            //this.accountSearch.searchValue=this.inscriptionLine[indexMenu].compte

            if (this.inscriptionLine.length > 0)
            {
                var i = 0
                for (i = 0; i < this.inscriptionLine.length; i++)
                {
                    //console.log(indexMenu + " : " + i)

                    if (i == indexMenu)
                    {this.inscriptionLine[i].openBank = true}
                    else
                    {this.inscriptionLine[i].openBank = false}
                }
            }
        },
        validateAccountState(index){
            if(this.fromApiAccount)
            {
                var accountExist = false
                var i = 0
                for (i = 0; i < this.fromApiAccount.length; i++)
                    {
                        if (this.fromApiAccount[i].number == this.inscriptionLine[index].compte)
                        {
                            accountExist = true
                        }
                    }

                if(this.inscriptionLine[index].compte.length > 0 && accountExist == true)
                    {
                        return true
                    }
                else
                    {
                        return false
                    }
            }
            else
            {return false}
        },
        validateAccount(index){

            if (this.fromApiAccount)
            {
                var fromAPIAccountId = 0

                var accountExist = false
                var i = 0
                for (i = 0; i < this.fromApiAccount.length; i++)
                    {
                        if (this.fromApiAccount[i].number == this.inscriptionLine[index].compte)
                        {
                            fromAPIAccountId = this.getFromApiAccountIndexFromNumber(this.fromApiAccount[i].number)
                            accountExist = true
                        }
                    }

                if(this.inscriptionLine[index].compte.length > 0 && accountExist == true)
                    {
                        this.inscriptionLine[this.accountSearch.accountIndex].description = this.fromApiAccount[fromAPIAccountId].description0
                        //this.inscriptionLine[this.accountSearch.accountIndex].compte = this.fromApiAccount[fromAPIAccountId].number
                        this.inscriptionLine[this.accountSearch.accountIndex].openMenu = false
                        this.addTransactionLine()
                        //return true
                    }
                else
                    {
                        this.inscriptionLine[this.accountSearch.accountIndex].description = ''
                        //this.inscriptionLine[this.accountSearch.accountIndex].compte = this.fromApiAccount[fromAPIAccountId].number
                        this.inscriptionLine[this.accountSearch.accountIndex].openMenu = true
                        //return false
                    }
            }

        },
        zeroDebit(index){
            this.inscriptionLine[index].debit = 0
            this.inscriptionLine[index].debitEntered = 0
        },
        zeroCredit(index){
            this.inscriptionLine[index].credit = 0
            this.inscriptionLine[index].creditEntered = 0
        },
        calculTaxes(){
            
            this.resetTaxes()

            if(this.inscriptionLine.length > 1) //verifier qu'il y a des comptes inscrit
            {
                //console.log('insc length : ' + this.inscriptionLine.length)

                let i
                for(i=0; i < this.inscriptionLine.length - 1; i++) //lire tous les ligne inscrite
                {
                    //console.log('xxxxxxxx : ' + this.inscriptionLine[i].compte)

                    if(this.inscriptionLine[i].compte != '')
                    {
                        //console.log('OK Y A KEKE CHOSE !')
                        let accountIndex = this.$accountIndexFromNumber(this.inscriptionLine[i].compte)
                        //console.log('INDEX : ' + accountIndex)

                        //ADDITIONNER LE TOTAL POUR OBTENIR LA TAXE À RETIRER
                        let totalPercentTaxe = 0; //Pourcentage total des taxes que l'ont doit soustraire du total 

                        if(this.getCompteGL[accountIndex].taxF == true){totalPercentTaxe = totalPercentTaxe + this.getActiveTaxes.taxes_rate[0].rateF}
                        if(this.getCompteGL[accountIndex].taxP == true){totalPercentTaxe = totalPercentTaxe + this.getActiveTaxes.taxes_rate[0].rateP}
                        if(this.getCompteGL[accountIndex].taxFIncluded == true){totalPercentTaxe = totalPercentTaxe + this.getActiveTaxes.taxes_rate[0].rateF}
                        if(this.getCompteGL[accountIndex].taxPIncluded == true){totalPercentTaxe = totalPercentTaxe + this.getActiveTaxes.taxes_rate[0].rateP}
                        if(this.getCompteGL[accountIndex].taxMotel == true){totalPercentTaxe = totalPercentTaxe + this.getActiveTaxes.taxes_rate[0].rateMotel}
                        if(this.getCompteGL[accountIndex].taxTire == true){totalPercentTaxe = totalPercentTaxe + this.getActiveTaxes.taxes_rate[0].rateTire}
                        
                        //console.log('totalPercentTaxe : ' + totalPercentTaxe)

                        //RÉTABLIR MONTANT SELON LE MONTANT ENTRÉ
                        if (this.inscriptionLine[i].debitEntered != 0)
                        {
                            this.inscriptionLine[i].debit = this.inscriptionLine[i].debitEntered
                        }
                        if (this.inscriptionLine[i].creditEntered != 0)
                        {
                            this.inscriptionLine[i].credit = this.inscriptionLine[i].creditEntered
                        }
                        //FIN - RÉTABLIR MONTANT SELON LE MONTANT ENTRÉ

                        //RETIRER LES TAXES DU MONTANT
                        if (this.inscriptionLine[i].debit != 0)
                        {
                            this.inscriptionLine[i].debit = this.inscriptionLine[i].debit / (1 + (totalPercentTaxe / 100))
                        }

                        if (this.inscriptionLine[i].credit != 0)
                        {
                            this.inscriptionLine[i].credit = this.inscriptionLine[i].credit / (1 + (totalPercentTaxe / 100))
                        }
                        //FIN - RETIRER LES TAXES DU MONTANT

                        console.log('s-total : ' + this.inscriptionLine[i].debit)

                        
                        //DÉBIT
                        if(this.inscriptionLine[i].debit != 0)
                        {
                            var taxDebit = 0

                            if(this.getCompteGL[accountIndex].taxF == true)
                            {
                                var txF = (this.inscriptionLine[i].debit * this.getActiveTaxes.taxes_rate[0].rateF) / 100
                                this.taxes.glFDebit += parseFloat(txF)
                                taxDebit += parseFloat(txF.toFixed(2))
                            }
                            else{this.taxes.glFDebit = 0}

                            if(this.getCompteGL[accountIndex].taxP == true)
                            {
                                var txP = (this.inscriptionLine[i].debit * this.getActiveTaxes.taxes_rate[0].rateP) / 100
                                this.taxes.glPDebit += parseFloat(txP)
                                taxDebit += parseFloat(txP.toFixed(2))

                            }
                            else{this.taxes.glPDebit = 0}

                            if(this.getCompteGL[accountIndex].taxFIncluded == true)
                            {
                                var txFInc = (this.inscriptionLine[i].debit * this.getActiveTaxes.taxes_rate[0].rateF) / 100
                                this.taxes.glFIncludeDebit += parseFloat(txFInc)
                                taxDebit += parseFloat(txFInc.toFixed(2))
                            }
                            else{this.taxes.getCompteGL = 0}

                            if(this.getCompteGL[accountIndex].taxPIncluded == true)
                            {
                                var txPInc = (this.inscriptionLine[i].debit * this.getActiveTaxes.taxes_rate[0].rateP) / 100
                                this.taxes.glPIncludeDebit += parseFloat(txPInc)
                                taxDebit += parseFloat(txPInc.toFixed(2))
                            }
                            else{this.taxes.glPIncludeDebit = 0}

                            if(this.getCompteGL[accountIndex].taxMotel == true)
                            {
                                var txMotel = (this.inscriptionLine[i].debit * this.getActiveTaxes.taxes_rate[0].rateMotel) / 100
                                this.taxes.glMotelDebit += parseFloat(txMotel)
                                taxDebit += parseFloat(txMotel.toFixed(2))
                            }
                            else{this.taxes.glMotelDebit = 0}
                            
                            if(this.getCompteGL[accountIndex].taxTire == true)
                            {
                                var txTire = (this.inscriptionLine[i].debit * this.getActiveTaxes.taxes_rate[0].rateTire) / 100
                                this.taxes.glTireDebit += parseFloat(txTire)
                                taxDebit += parseFloat(txTire.toFixed(2))
                            }
                            else{this.taxes.glTireDebit = 0}

                            this.inscriptionLine[i].debit = this.inscriptionLine[i].debitEntered - taxDebit
                        }
                        //FIN - DÉBIT 

                        //CRÉDIT 
                        if(this.inscriptionLine[i].credit != 0)
                        {
                            var taxCredit = 0

                            if(this.getCompteGL[accountIndex].taxF == true)
                            {
                                var cF = (this.inscriptionLine[i].credit * this.getActiveTaxes.taxes_rate[0].rateF) / 100
                                this.taxes.glFCredit += parseFloat(cF)
                                taxCredit += parseFloat(cF.toFixed(2))
                            }
                            else{this.taxes.glFCredit = 0}

                            if(this.getCompteGL[accountIndex].taxP == true)
                            {
                                var cP = (this.inscriptionLine[i].credit * this.getActiveTaxes.taxes_rate[0].rateP) / 100
                                this.taxes.glPCredit += parseFloat(cP)
                                taxCredit += parseFloat(cP.toFixed(2))
                            }
                            else{this.taxes.glPCredit = 0}

                            if(this.getCompteGL[accountIndex].taxFIncluded == true)
                            {
                                var cFInc = (this.inscriptionLine[i].credit * this.getActiveTaxes.taxes_rate[0].rateF) / 100
                                this.taxes.glFIncludeCredit += parseFloat(cFInc)
                                taxCredit += parseFloat(cFInc.toFixed(2))
                            }
                            else{this.taxes.glFIncludeCredit = 0}

                            if(this.getCompteGL[accountIndex].taxPIncluded == true)
                            {
                                var cPInc = (this.inscriptionLine[i].credit * this.getActiveTaxes.taxes_rate[0].rateP) / 100
                                this.taxes.glPIncludeCredit += parseFloat(cPInc)
                                taxCredit += parseFloat(cPInc.toFixed(2))
                            }
                            else{this.taxes.glPIncludeCredit = 0}
                            
                            if(this.getCompteGL[accountIndex].taxMotel == true)
                            {
                                var cMotel = (this.inscriptionLine[i].credit * this.getActiveTaxes.taxes_rate[0].rateMotel) / 100
                                this.taxes.glMotelCredit += parseFloat(cMotel)
                                taxCredit += parseFloat(cMotel.toFixed(2))
                            }
                            else{this.taxes.glMotelCredit = 0}

                            if(this.getCompteGL[accountIndex].taxTire == true)
                            {
                                var cTire = (this.inscriptionLine[i].credit * this.getActiveTaxes.taxes_rate[0].rateTire) / 100
                                this.taxes.glTireCredit += parseFloat(cTire)
                                taxCredit += parseFloat(cTire.toFixed(2))
                            }
                            else{this.taxes.glTireCredit = 0}

                            this.inscriptionLine[i].credit = this.inscriptionLine[i].creditEntered - taxCredit
                        }
                        //FIN - CRÉDIT
                    }
                }
            }

            return null

        }
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getTheme', 'getApiAdress', 'getApiAdd', 'getPageSize', 'getworkLicence', 'getApiKey', 'getCombo', 'getCheckSize', 'getScreenSize', 'getActiveTaxes', 'getTaxes', 'getCompteGL']),
        ////cTaxes(){
        ////    this.calculTaxes()
        ////    return this.taxes
        ////},
        checkAllField() {
            //if (this.activeObj.NomFonction == '')
            //{return true}
            //else
            //{return false}
            return false
        },
        validateAccountField(id){

            if(id == 0){return false}

            return true
        },
        cssFirstLetter() {
            if (this.firstLetterNotUpper)
                {return ''}
            else
                {return 'btnFirstLetter'}
            
        },
        rechercheAutoComplete() {
            if(this.fromApiAccount)
            {
                var search = ''

                if(this.inscriptionLine.length > 1)
                {search = this.inscriptionLine[this.accountSearch.accountIndex].compte.toLowerCase().trim();}
                
                if (!search) return this.fromApiAccount.filter(c => c.isActive == true);

                return this.fromApiAccount.filter(c => c.description0.toLowerCase().indexOf(search) > -1 || c.number.toLowerCase().indexOf(search) > -1 && c.isActive == true);
            }
            else
            {return this.fromApiAccount}
        },
        calculBalance(){
            //FONCTION POUR AFFICHER SI LE COMPTE BALANCE OU NON JUSTE AU DESSU DES LIGNES D'ENTRÉ DES COMPTES
            var totalTaxCredit
            var totalTaxDebit

            totalTaxDebit = parseFloat(this.taxes.glFDebit.toFixed(2)) + parseFloat(this.taxes.glPDebit.toFixed(2)) + parseFloat(this.taxes.glFIncludeDebit.toFixed(2)) + 
                            parseFloat(this.taxes.glPIncludeDebit) + parseFloat(this.taxes.glMotelDebit.toFixed(2)) + parseFloat(this.taxes.glTireDebit.toFixed(2));

            totalTaxCredit = parseFloat(this.taxes.glFCredit.toFixed(2)) + parseFloat(this.taxes.glPCredit.toFixed(2)) + parseFloat(this.taxes.glFIncludeCredit.toFixed(2)) + 
                             parseFloat(this.taxes.glPIncludeCredit.toFixed(2)) + parseFloat(this.taxes.glMotelCredit.toFixed(2)) + parseFloat(this.taxes.glTireCredit.toFixed(2));

            var sendValue = 0

            var totalD = 0
            var totalC = 0

            var d = 0
            var c = 0

            for (d=0; d < this.inscriptionLine.length; d++)
            {
                totalD += this.inscriptionLine[d].debit
            }

            for (c=0; c < this.inscriptionLine.length; c++)
            {
                totalC += this.inscriptionLine[c].credit
            }

            totalTaxDebit = parseFloat(totalTaxDebit.toFixed(2))
            totalTaxCredit = parseFloat(totalTaxCredit.toFixed(2))

            totalD = totalD + totalTaxDebit
            totalC = totalC + totalTaxCredit
            
            sendValue = totalC - totalD

            return sendValue
        },
        totalDebit(){
            var totalD = 0
            var d = 0

            for (d=0; d < this.inscriptionLine.length; d++)
            {
                totalD += this.inscriptionLine[d].debit
            }

            return totalD
        },
        totalCredit(){
            var totalC = 0
            var c = 0

            for (c=0; c < this.inscriptionLine.length; c++)
            {
                totalC += this.inscriptionLine[c].credit
            }

            return totalC
        },
        totalTaxDebit(){
            var totalD = 0


            totalD = parseFloat(this.taxes.glFDebit.toFixed(2)) + parseFloat(this.taxes.glPDebit.toFixed(2)) + parseFloat(this.taxes.glFIncludeDebit.toFixed(2)) + parseFloat(this.taxes.glPIncludeDebit.toFixed(2)) + parseFloat(this.taxes.glMotelDebit.toFixed(2)) + parseFloat(this.taxes.glTireDebit.toFixed(2))

            return totalD
        },
        totalTaxCredit(){
            var totalC = 0

            totalC = parseFloat(this.taxes.glFCredit.toFixed(2)) + parseFloat(this.taxes.glPCredit.toFixed(2)) + parseFloat(this.taxes.glFIncludeCredit.toFixed(2)) + parseFloat(this.taxes.glPIncludeCredit.toFixed(2)) + parseFloat(this.taxes.glMotelCredit.toFixed(2)) + parseFloat(this.taxes.glTireCredit.toFixed(2))

            return totalC
        },
        fromApiAccount : () => store.getters.getCompteGL

    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() //charger
        this.loadApiAccount() //charger des compte
        this.InitialState = this.$CObj(this.activeObj)
        this.inscriptionLineInitial = this.$CObj(this.inscriptionLine)
        this.taxesInitial = this.$CObj(this.taxes)
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
                this.loadApi()
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/views/inscription.scss";
@import "../../../../assets/css/components/itemListCss.scss";
</style>